/* In-house Size Guide (replaces Kiwi Size Chart).
   The trigger and <dialog> are server-rendered inside the main product section
   (snippets/zorali-size-guide.liquid), so a colour swatch swap brings the new
   product's chart with it. Everything here is delegated from document, so it
   keeps working after any section swap. No network calls. */
(function () {
  if (window.__zsg) return;
  window.__zsg = true;

  var html = document.documentElement;

  // Dark launch: in-house only answers for browsers that opted in (?zsize=inhouse).
  // Once the snippet stops marking the trigger data-zsg-dark (cutover), it always answers.
  function active() {
    return html.classList.contains('zsg-inhouse') || !document.querySelector('.zsg-wrap[data-zsg-dark]');
  }

  /* ---------- units: same maths Kiwi used (cm / 2.54, max 1 decimal, both ends of a range) ---------- */
  function toInches(cm) {
    return cm.split(' - ').map(function (p) {
      var n = parseFloat(p);
      if (isNaN(n)) return p;
      return String(Math.round((n / 2.54) * 10 + 1e-9) / 10);
    }).join(' - ');
  }
  function setUnit(dlg, unit) {
    dlg.setAttribute('data-zsg-unit', unit);
    dlg.querySelectorAll('[data-zsg-cm]').forEach(function (td) {
      var cm = td.getAttribute('data-zsg-cm');
      td.textContent = unit === 'in' ? toInches(cm) : cm;
    });
    dlg.querySelectorAll('[data-zsg-unit-set]').forEach(function (b) {
      var on = b.getAttribute('data-zsg-unit-set') === unit;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  /* ---------- open / close ---------- */
  // The dialog renders inside the product section but opens from <body> (as
  // Kiwi's modal did), so section-scoped theme CSS never reaches the tables.
  function findDialog(trigger) {
    var id = trigger && trigger.getAttribute('aria-controls');
    if (!id) return null;
    var scope = trigger.closest('.shopify-section') || document;
    return scope.querySelector('dialog#' + CSS.escape(id)) || document.getElementById(id);
  }

  function open(dlg) {
    if (!dlg || dlg.open) return;
    document.querySelectorAll('body > dialog.zsg').forEach(function (d) { if (d !== dlg) d.remove(); });
    if (dlg.parentNode !== document.body) {
      var ph = document.createComment('zsg');
      dlg.parentNode.insertBefore(ph, dlg);
      dlg.__zsgHome = ph;
      document.body.appendChild(dlg);
    }
    setUnit(dlg, dlg.getAttribute('data-zsg-unit') || 'cm');
    html.classList.add('zsg-open');
    dlg.showModal();
    // Focus the panel, not the close button (showModal's default), so no focus ring shows on open.
    var inner = dlg.querySelector('.zsg-inner');
    if (inner) inner.focus({ preventScroll: true });
    dlg.scrollTop = 0;
    requestAnimationFrame(function () { requestAnimationFrame(function () { dlg.classList.add('zsg-visible'); }); });
  }

  function close(dlg) {
    if (!dlg || !dlg.open || dlg.__zsgClosing) return;
    dlg.__zsgClosing = true;
    dlg.classList.remove('zsg-visible');
    setTimeout(function () {
      dlg.__zsgClosing = false;
      dlg.close();
      html.classList.remove('zsg-open');
      var ph = dlg.__zsgHome;
      dlg.__zsgHome = null;
      if (ph && ph.isConnected) ph.parentNode.replaceChild(dlg, ph);
      else dlg.remove(); // its section was swapped out while it was open
    }, 300);
  }

  function pageTrigger() {
    var all = document.querySelectorAll('.zsg-link');
    for (var i = 0; i < all.length; i++) if (all[i].offsetParent !== null) return all[i];
    return all[0] || null;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var link = t.closest('.zsg-link');
    if (link) { e.preventDefault(); open(findDialog(link)); return; }

    // Existing "See full size guide" / "Size guide" hooks on the zorali-pdp and
    // Daylight templates used to click Kiwi's link. Capture phase, so they open this instead.
    var hook = t.closest('[data-zpdp-kiwi], [data-drd-kiwi]');
    if (hook && active()) {
      var tr = pageTrigger();
      if (tr) { e.preventDefault(); e.stopImmediatePropagation(); open(findDialog(tr)); }
      return;
    }

    var dlg = t.closest('dialog.zsg');
    if (!dlg) return;
    if (t.closest('[data-zsg-close]') || t === dlg) { close(dlg); return; }
    var unit = t.closest('[data-zsg-unit-set]');
    if (unit) setUnit(dlg, unit.getAttribute('data-zsg-unit-set'));
  }, true);

  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (!t.closest || (e.key !== 'Enter' && e.key !== ' ')) return;
    var el = t.closest('.zsg-link, [data-zsg-unit-set]');
    if (!el) return;
    e.preventDefault();
    el.click();
  });

  // Esc: animate out like the close button instead of snapping shut.
  document.addEventListener('cancel', function (e) {
    if (e.target.matches && e.target.matches('dialog.zsg')) { e.preventDefault(); close(e.target); }
  }, true);

  // Overland: the EU / US picker in the size column header.
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel.matches || !sel.matches('select.zsg-country')) return;
    var code = sel.value.toLowerCase();
    var table = sel.closest('table');
    table.querySelectorAll('[data-zsg-c-' + code + ']').forEach(function (td) {
      td.textContent = td.getAttribute('data-zsg-c-' + code);
    });
  });

  // Classic template: its colour circles (.sibling-product-link, assets/product_page.js)
  // swap the product client-side from /products/<handle>.js without replacing the
  // main section, so the Size Guide would keep the previous colour's title and chart.
  // Re-render just our trigger and dialog from the new product's main section.
  document.addEventListener('click', function (e) {
    var sib = e.target.closest && e.target.closest('.sibling-product-link');
    var handle = sib && sib.getAttribute('data-handle');
    var wrap = document.querySelector('.zsg-wrap');
    var section = wrap && wrap.closest('.shopify-section');
    if (!handle || !section || !section.id) return;
    var id = section.id.replace(/^shopify-section-/, '');
    fetch('/products/' + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(id))
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (text) {
        if (!text) return;
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var nw = doc.querySelector('.zsg-wrap'), nd = doc.querySelector('dialog.zsg');
        var ow = document.querySelector('.zsg-wrap'), od = section.querySelector('dialog.zsg');
        document.querySelectorAll('body > dialog.zsg').forEach(function (d) { if (!d.open) d.remove(); });
        if (ow) { if (nw) ow.replaceWith(document.importNode(nw, true)); else ow.remove(); }
        if (od) { if (nd) od.replaceWith(document.importNode(nd, true)); else od.remove(); }
      })
      .catch(function () {});
  });

  // Column highlight on hover (rows highlight with CSS :hover).
  document.addEventListener('mouseover', function (e) {
    var cell = e.target.closest && e.target.closest('.zsg-table .zsg-cell');
    var table = cell && cell.closest('table');
    document.querySelectorAll('.zsg-col-hover').forEach(function (c) { c.classList.remove('zsg-col-hover'); });
    if (!cell) return;
    var idx = cell.cellIndex;
    [].forEach.call(table.rows, function (r) {
      if (r.cells.length === cell.parentNode.cells.length && r.cells[idx]) r.cells[idx].classList.add('zsg-col-hover');
    });
  });
})();
